import { render } from "./OpenIcon.vue?vue&type=template&id=605b18ea&scoped=true"
const script = {}

import "./OpenIcon.vue?vue&type=style&index=0&id=605b18ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-605b18ea"]])

export default __exports__